import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';
import moment from 'moment/moment';


import '../Resources/dashboard.css';


function Add_service(){

  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 
//saving default values with usestate
const state = useState();

//service_name
const[service_name,setservice_name]=useState();const updateservice_name = (event) => { setservice_name(event.target.value);}; const[service_name_er,setservice_name_er]=useState();
//service_code
const[service_code,setservice_code]=useState();const updateservice_code = (event) => { setservice_code(event.target.value);}; const[service_code_er,setservice_code_er]=useState();
//service_type
const[service_type,setservice_type]=useState();const updateservice_type = (event) => { setservice_type(event.target.value);}; const[service_type_er,setservice_type_er]=useState();
//service_category
const[service_category,setservice_category]=useState();const updateservice_category = (event) => { setservice_category(event.target.value);}; const[service_category_er,setservice_category_er]=useState();
//service_status
const[service_status,setservice_status]=useState();const updateservice_status = (event) => { setservice_status(event.target.value);}; const[service_status_er,setservice_status_er]=useState();
//description
const[description,setdescription]=useState();const updatedescription = (event) => { setdescription(event.target.value);}; const[description_er,setdescription_er]=useState();
//sales_rate
const[sales_rate,setsales_rate]=useState();const updatesales_rate = (event) => { setsales_rate(event.target.value);}; const[sales_rate_er,setsales_rate_er]=useState();
//service_cost
const[service_cost,setservice_cost]=useState();const updateservice_cost = (event) => { setservice_cost(event.target.value);}; const[service_cost_er,setservice_cost_er]=useState();
//discount_per
const[discount_per,setdiscount_per]=useState();const updatediscount_per = (event) => { setdiscount_per(event.target.value);}; const[discount_per_er,setdiscount_per_er]=useState();
//Variables
const[data,setdata] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();



//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();





  
//******************* ADD SERVICE ITEM FUNCTION START ********************//
function addservice(){

  //Setting Error Variables
setservice_name_er(" ");setservice_code_er(" ");setservice_type_er(" ");setservice_category_er(" ");setservice_status_er();setdescription_er();
setsales_rate_er(" ");setservice_cost_er(" ");setdiscount_per_er(" ");seterror_msg(" ");



  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))){
 
 
  axios.post("bt-add-serviceitem", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Service_name :service_name,
   Service_code :service_code,
   Type:service_type,
   Category : service_category,
   Status:service_status,
   Description:description,
   Sales_rate:sales_rate,
   Service_cost:service_cost,
   Discount_per:discount_per,


  })
  .then((response) => {

        //Product Item Limit Reached
        if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
        

  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 if(response.data.validatorerror){
  setservice_name_er(response.data.validatorerror.Service_name);
  setservice_code_er(response.data.validatorerror.Service_code);
  setservice_type_er(response.data.validatorerror.Type);
  setservice_category_er(response.data.validatorerror.Category);
  setservice_status_er(response.data.validatorerror.Status);
  setdescription_er(response.data.validatorerror.Description);
  setsales_rate_er(response.data.validatorerror.Sales_rate);
  setservice_cost_er(response.data.validatorerror.Service_cost);
  setdiscount_per_er(response.data.validatorerror.Discount_per);
  seterror_msg("Cannot Add Service Item!");  
}
//Invalid Entries
if(response.data.error==102){ 
  
  setservice_name_er(response.data.service_name_er);
  setservice_code_er(response.data.service_code_er);
  setservice_type_er(response.data.type_er);
  setservice_category_er(response.data.category_er);
  setservice_status_er(response.data.status_er);
  setdescription_er(response.data.description_er);
  setsales_rate_er(response.data.sales_rate_er);
  setservice_cost_er(response.data.service_cost_er);
  setdiscount_per_er(response.data.discount_per_er);

 
  seterror_msg("Cannot Add Service Item!");  }


  //Invalid Entries
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Entered Successfully
   if(response.data.successvar==1){        document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Service Item !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* ADD SERVICE ITEM FUNCTION END ********************//


 




return(
    <>
                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("create-form").style.display="none"; }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Add Service</h4>
                    <div class="form-sample">
                      <p class="card-description">add your service details here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Code<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="SER0001" id="service_code" value={service_code} onChange={updateservice_code} />
                            <code>{service_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Service Name" id="service_name" value={service_name} onChange={updateservice_name} />
                            <code>{service_name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">     
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Type Regular" id="service_type" value={service_type} onChange={updateservice_type}/>
                            <code>{service_type_er}</code>
                            </div>
                          </div>
                        </div> 
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Category" id="service_category" value={service_category} onChange={updateservice_category} />
                            <code>{service_category_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sales Rate</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="sales_rate" value={sales_rate} onChange={updatesales_rate}/>
                              <code>{sales_rate_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Cost</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="1500.00" id="service_cost" value={service_cost} onChange={updateservice_cost} />
                            <code>{service_cost_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="10.00" id="discount_per" value={discount_per} onChange={updatediscount_per} />
                              <code>{discount_per_er}</code>
                            </div>
                          </div>
                        </div>    
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Status</label>
                            <div class="col-sm-9">
                            <select class="form-control" id="product_status" style={{padding:"1rem"}} value={service_status} onChange={updateservice_status} >
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{service_status_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                    
                      <div class="form-group">
                        <label for="exampleTextarea1">Description</label>
                        <textarea class="form-control" rows="2" id="description" value={description} onChange={updatedescription} ></textarea>
                       <code>{description_er}</code>
                      </div>
            
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={addservice}>Add Service</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
    </>

);

}

export default Add_service;